<template>
  <Teleport to="body">
  <div class="c-modal modal show in" tabindex="-1" role="dialog">
    <div ref="modalBackdrop"  class="c-modal-backdrop modal-backdrop show in" @click="$emit('close')" style="height: 100%;"></div>
    <div ref="modalDialog" class="c-modal-dialog" :class="`modal-dialog modal-${size}`" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
          <h3 class="modal-title" style="font-weight: 600;">
            <slot name="title">{{ title }}</slot>
          </h3>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
  </Teleport>
</template>


<script>
import Teleport from 'vue2-teleport';


export default {
  components: {
    Teleport,
  },
  mounted() {

    const $modalContentHeight = this.$refs['modalDialog'].offsetHeight + 60; // 60 is a margin

    this.$refs['modalBackdrop'].style.height = `${$modalContentHeight}px`;


    Array.from(document.querySelectorAll('.modal')).forEach(function(el){
      el.scrollTo(0,0)
    })

    document.body.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto';
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'lg'
    }
  },
  emits: ['close']
}
</script>

<style scoped>
.c-modal-backdrop {
  /*position: fixed;*/
  /*top: 0;*/
  /*left: 0;*/
  /*height: 100%;*/
  min-height: 100%;
}
</style>
